import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';

import { withClientId } from 'hocs';
import { wsClient } from 'index';
import {
	accumulateBlockAttendanceByHolder,
	getBlock,
	listScheduleStats,
	getBlockAttendanceByHolder,
	listBlocks,
	getSchedule,
} from 'redux/modules/model/attendance';
import {
	blockDetailsSelector,
	detectablesBlockDetailsLoadingSelector,
} from 'redux/selectors';
import { bem } from 'utils/helpers';

import BlockAssignments from './components/block-assignments';
import BlockDetails from './components/block-details';
import { Button, Col, Row, SubmitRow, Skeleton, notification } from 'elements';

import './index.scss';

const em = (e, m) => bem('block-info', e, m);

class BlockInfo extends Component {
	constructor(props) {
		super(props);
		this.state = {
			edit: false,
			detailsEditing: {
				startTime: null,
				endTime: null,
				siteId: null,
				zoneId: null,
			},
			assignmentsOverrideAttendanceBuffer: {},
		};
	}

	componentDidMount = () => {
		const { clientId, scheduleId, blockId, getBlock } = this.props;
		getBlock({ clientId, scheduleId, blockId });
	};

	detailsEditingHandler = editingState => {
		this.setState(state => ({
			detailsEditing: {
				...state.detailsEditing,
				...editingState,
			},
		}));
	};

	overrideAttendanceBufferStateHandler = overrideAttendanceBufferState => {
		this.setState(state => ({
			assignmentsOverrideAttendanceBuffer: {
				...overrideAttendanceBufferState,
			},
		}));
	};

	handleCancel = () => {
		this.setState(() => ({ edit: false }));
	};

	handleSubmit = () => {
		const {
			clientId,
			scheduleId,
			blockId,
			getBlock,
			getBlockAttendanceByHolder,
			listScheduleStats,
			listBlocks,
			getSchedule,
		} = this.props;
		const {
			detailsEditing: { startTime, endTime, siteId, zoneId },
		} = this.state;
		const { assignmentsOverrideAttendanceBuffer } = this.state;
		const data = {
			clientId,
			scheduleId,
			blockId,
			siteId,
			changes: {
				startTime,
				endTime,
				zoneId,
				siteId,
			},
		};
		wsClient
			.request({
				messageType: 'attendance.schedule.edit-block',
				payload: data,
			})
			.then(res => {
				if (res.payload) {
					notification.error({
						message: 'Error',
						description: `${res.payload.message}${
							res.payload.errors[0].field === 'startTime|endTime'
								? ', End time cannot be earlier than Start time.'
								: '.'
						}`,
						placement: 'bottomLeft',
					});
				} else {
					notification.success({
						message: 'Success',
						description: 'Successfully saved',
						placement: 'bottomLeft',
					});
				}
				getBlock({ clientId, scheduleId, blockId });
				listBlocks({ clientId, scheduleId });
				getSchedule({ clientId, scheduleId });
				assignmentsOverrideAttendanceBuffer;
				for (let clientReference in assignmentsOverrideAttendanceBuffer) {
					if (
						assignmentsOverrideAttendanceBuffer.hasOwnProperty(
							clientReference,
						)
					) {
						const status =
							assignmentsOverrideAttendanceBuffer[
								clientReference
							];
						if (status) {
							wsClient
								.request({
									messageType:
										'attendance.schedule.override-attendance',
									payload: {
										clientId,
										scheduleId,
										blockId,
										clientReference,
										status,
									},
								})
								.then(() => {
									getBlockAttendanceByHolder({
										clientId,
										scheduleId,
										blockId,
									});
									listScheduleStats({ clientId });
								});
						}
					}
				}
			});
		this.handleCancel();
	};

	render = () => {
		const { scheduleId, blockId, blockDetails, loading } = this.props;
		return (
			<div className={em()}>
				{this.state.edit ? (
					<a
						className={em('back-link')}
						onClick={e => {
							e.preventDefault();
							this.setState(() => ({ edit: false }));
						}}
					>
						&laquo; Cancel
					</a>
				) : (
					<a
						className={em('edit-link')}
						onClick={e => {
							e.preventDefault();
							this.setState(() => ({ edit: true }));
						}}
					>
						<svg
							viewBox="0 0 14 16"
							version="1.1"
							width="36"
							height="36"
						>
							<path
								fillRule="evenodd"
								fill="currentColor"
								d="M0 12v3h3l8-8-3-3-8 8zm3 2H1v-2h1v1h1v1zm10.3-9.3L12 6 9 3l1.3-1.3a.996.996 0 0 1 1.41 0l1.59 1.59c.39.39.39 1.02 0 1.41z"
							/>
						</svg>
					</a>
				)}
				<h2 className={em('title')}>
					{blockDetails && blockDetails.name}
				</h2>
				<h3 className={em('subtitle')}>Details</h3>
				<BlockDetails
					{...{ scheduleId, blockId }}
					edit={this.state.edit}
					editingStateCallback={this.detailsEditingHandler}
					values={this.state.detailsEditing}
				/>
				<h3 className={em('subtitle')}>Assignments</h3>

				<BlockAssignments
					{...{ scheduleId, blockId }}
					edit={this.state.edit}
					overrideAttendanceBufferStateCallback={
						this.overrideAttendanceBufferStateHandler
					}
				/>
				{this.state.edit && (
					<SubmitRow>
						<Row type="flex" gutter={20}>
							<Col>
								<Button
									htmlType="submit"
									type="primary"
									wide
									onClick={this.handleSubmit}
								>
									Save
								</Button>
							</Col>
							<Col>
								<Button wide onClick={this.handleCancel}>
									Cancel
								</Button>
							</Col>
						</Row>
					</SubmitRow>
				)}
			</div>
		);
	};
}

export const selectors = createStructuredSelector({
	blockDetails: blockDetailsSelector,
	loading: detectablesBlockDetailsLoadingSelector, // TODO add when finish optimize
});
export const actions = {
	getBlock,
	getBlockAttendanceByHolder,
	accumulateBlockAttendanceByHolder,
	listScheduleStats,
	listBlocks,
	getSchedule,
};
export default compose(
	withClientId,
	connect(
		selectors,
		actions,
	),
)(BlockInfo);



// WEBPACK FOOTER //
// ./src/pages/attendance/attendance-schedule-detail/components/block-info/index.js